
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/SAAS-videos",
      function () {
        return require("private-next-pages/SAAS-videos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/SAAS-videos"])
      });
    }
  